import { useEffect, useState } from "react";
import { User, UserPlus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, digits } from "@/lib/api";

const looksPhone = (s) => digits(s).length >= 8 && /^[\d\s()+-]+$/.test(s);

function Results({ q, list, pick, newOne }) {
  return (
    <ul className="absolute z-20 mt-1 max-h-72 w-full overflow-y-auto rounded-lg border bg-popover shadow-lg" onMouseDown={(e) => e.preventDefault()} data-testid="order-customer-results">
      {list.map((c) => (
        <li key={c.id}>
          <button type="button" onClick={() => pick(c)} className="flex w-full flex-col px-3 py-2 text-left text-sm transition-colors hover:bg-accent" data-testid={`order-customer-result-${c.id}`}>
            <span className="font-medium">{c.name}</span>
            <span className="truncate text-xs text-muted-foreground">{[c.phone, c.address].filter(Boolean).join(" · ") || "sem telefone"}</span>
          </button>
        </li>
      ))}
      <li>
        <button type="button" onClick={newOne} className="flex w-full items-center gap-2 border-t px-3 py-2.5 text-left text-sm font-medium text-primary transition-colors hover:bg-accent" data-testid="order-customer-new-btn">
          <UserPlus className="h-4 w-4" />Novo cliente: {q}
        </button>
      </li>
    </ul>
  );
}

export function CustomerSearch({ customer, setCustomer, onPick }) {
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const s = q.trim();
  useEffect(() => {
    if (s.length < 2) { setList([]); return undefined; }
    const t = setTimeout(() => api.get("/orders/customer-search", { params: { q: s } }).then((r) => setList(r.data)).catch(() => setList([])), 300);
    return () => clearTimeout(t);
  }, [s]);
  const done = () => { setQ(""); setShow(false); };
  const pick = (c) => { setCustomer({ name: c.name, phone: c.phone || "" }); onPick(c); done(); };
  const newOne = () => { setCustomer(looksPhone(s) ? { name: "", phone: s } : { name: s, phone: "" }); done(); };
  if (customer.name || customer.phone) {
    return (
      <div className="space-y-2 rounded-lg border p-3" data-testid="order-customer-card">
        <div className="flex items-center justify-between text-sm">
          <span className="flex items-center gap-2 font-semibold"><User className="h-4 w-4" />Cliente</span>
          <button type="button" onClick={() => setCustomer({ name: "", phone: "" })} className="flex items-center gap-1 text-xs text-muted-foreground transition-colors hover:text-foreground" data-testid="order-customer-clear"><X className="h-3.5 w-3.5" />Trocar</button>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <Input value={customer.name} onChange={(e) => setCustomer({ ...customer, name: e.target.value })} placeholder="Nome *" data-testid="order-customer-name-input" />
          <Input value={customer.phone} onChange={(e) => setCustomer({ ...customer, phone: e.target.value })} placeholder="Telefone com DDD" inputMode="tel" data-testid="order-customer-phone-input" />
        </div>
      </div>
    );
  }
  return (
    <div className="relative" data-testid="order-customer-search">
      <User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input value={q} onChange={(e) => { setQ(e.target.value); setShow(true); }} onFocus={() => setShow(true)} onBlur={() => setShow(false)}
        placeholder="Pesquisar cliente (nome ou telefone)..." className="h-12 pl-9" data-testid="order-customer-search-input" />
      {show && s.length >= 2 && <Results q={s} list={list} pick={pick} newOne={newOne} />}
    </div>
  );
}
